import { FC } from "react"
import LoginPengguna from "laman/loginPengguna/LoginPengguna"

const EditAkun: FC<IEditAkun> = (p) => {
  return <LoginPengguna editAkun/>
}

export default EditAkun

interface IEditAkun{}